import { render } from "./ProductDetail_AuditDataMarket.vue?vue&type=template&id=44b3e771&scoped=true"
import script from "./ProductDetail_AuditDataMarket.vue?vue&type=script&lang=js"
export * from "./ProductDetail_AuditDataMarket.vue?vue&type=script&lang=js"

import "./ProductDetail_AuditDataMarket.vue?vue&type=style&index=0&id=44b3e771&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b3e771"]])

export default __exports__